// EventMarkerContainer; 완성본

import { useContext, useEffect, useState } from 'react';
import { useMap } from 'react-kakao-maps-sdk';
import type { Location } from '../../domain/models/locations/Location';
import { EventMarkerContainerProps } from '../../types/OfflineLocation';
import { CustomMapMarker } from './CustomMapMarker';

const EventMarkerContainer = ({
  MarkerContext,
  pos,
  onChangePositionState,
  forceDarkMode,
  offsetPx = 30, // 데스크탑 기본값
  offsetPy = 50 // 모바일 기본값
}: EventMarkerContainerProps) => {
  const {
    clickedMarkerId,
    handleMarkerClick
  }: { clickedMarkerId: string; handleMarkerClick: (key: string) => void } =
    useContext(MarkerContext);
  const map = useMap();

  const [isSelected, setIsSelected] = useState(false);

  // pos에서 고유 식별자 생성 - latitude과 longitude를 결합
  const key = pos.locationId;

  useEffect(() => {
    // 상태가 변경될 때마다 실행
    if (clickedMarkerId !== null) {
      if (key === clickedMarkerId) {
        setIsSelected(true);
        // pos.isLiked ? setMarkerImg(clickHeart) : setMarkerImg(clickSiteType);
        // setWidth(48);
        // setHeight(55);
      } else {
        setIsSelected(false);
        // pos.isLiked ? setMarkerImg(unclickHeart) : setMarkerImg(unclickSiteType);
        // setWidth(30);
        // setHeight(35);
      }
    }
  }, [clickedMarkerId, key]);

  const handleCustomMarkerClick = (location: Location) => {
    const markerLatLng = new kakao.maps.LatLng(
      Number(location.latitude),
      Number(location.longitude)
    );

    // projection 객체 얻기
    const projection = map.getProjection();
    const point = projection.pointFromCoords(markerLatLng);

    // 모바일 환경 감지
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      point.y += offsetPy; // 모바일은 offsetPy만큼 아래로
    } else {
      point.y -= offsetPx; // 데스크탑은 offsetPx만큼 위로
    }

    // 다시 좌표로 변환
    const newCenter = projection.coordsFromPoint(point);

    // 지도 중심 이동
    map.panTo(newCenter);

    // 기존 로직 실행
    handleMarkerClick(key);
    onChangePositionState(pos);
  };

  // 우선순위: 이벤트 (생일카페, 전광판, 체험공간) > 성지 (맛집/촬영지/성지 등) > 찜
  const EVENT_PRIORITY_CATEGORIES = new Set(['birthday_cafe', 'billboard_ad', 'experience_space']);
  const hasEventPriority = Array.isArray(pos.events)
    ? pos.events.some((e) => EVENT_PRIORITY_CATEGORIES.has(e.category))
    : false;
  const hasFootprintPriority =
    !hasEventPriority &&
    (pos.footprints.length > 0 ||
      ['foodie_spot', 'filming_location', 'landmark'].includes(pos.siteType));
  const shouldUseLikedColor = pos.isLiked && !hasEventPriority && !hasFootprintPriority;

  const eventPurple = forceDarkMode ? '#654CFF' : '#5C3DFA';
  const defaultNeutral = forceDarkMode ? '#9389D0' : '#382599';

  const resolvedMarkerColor = shouldUseLikedColor
    ? '#FF5492'
    : isSelected
      ? eventPurple
      : defaultNeutral;

  const resolvedShadowColor =
    shouldUseLikedColor && isSelected
      ? '#FF5492'
      : isSelected && forceDarkMode
        ? '0px 0px 16.8px 6px #654CFF'
        : isSelected
          ? '#654CFF'
          : forceDarkMode
            ? '#654CFF'
            : '#5C3DFA';

  // 아이콘 우선순위: 이벤트/발도장 우선 시 하트 아이콘 숨김, 찜만 있을 때만 하트
  const iconSrc =
    hasEventPriority || hasFootprintPriority
      ? `/assets/icons/graphic-3d/${pos.siteTypeIconName()}.png`
      : shouldUseLikedColor
        ? '/assets/icons/graphic-3d/3D.like.png'
        : undefined;

  // const resolvedMarkerColor = pos.isLiked
  //   ? '#FF5492'
  //   : isSelected
  //     ? '#5C3DFA'    //여기
  //     : forceDarkMode
  //       ? '#AFA3E8' // 다크모드에서 선택되지 않은 마커
  //       : '#382599'; // 라이트모드에서 선택되지 않은 마커

  // const resolvedShadowColor =
  //   pos.isLiked && isSelected
  //     ? '#FF5492'
  //     : isSelected && forceDarkMode
  //       ? '0px 0px 16.8px 6px #5C3DF9'
  //       : isSelected
  //         ? '#5C3DFA'
  //         : forceDarkMode
  //           ? '#AFA3E8' // 다크모드에서 선택되지 않은 마커의 쉐도우
  //           : '#382599'; // 라이트모드에서 선택되지 않은 마커의 쉐도우
  // const resolvedMarkerColor = pos.isLiked ? '#FF5492' : isSelected ? '#5C3DFA' : '#382599';

  // const resolvedShadowColor =
  //   pos.isLiked && isSelected
  //     ? '#FF5492'
  //     : isSelected && forceDarkMode
  //       ? '0px 0px 16.8px 6px #5C3DF9' // 다크모드에서 선택된 네이비 마커만
  //       : isSelected
  //         ? '#5C3DFA' // 라이트모드에서 선택된 마커
  //         : '#382599';
  return (
    <CustomMapMarker
      location={pos}
      onClickMarker={handleCustomMarkerClick}
      isSelected={isSelected}
      forceDarkMode={forceDarkMode}
      markerColor={resolvedMarkerColor}
      shadowColor={resolvedShadowColor}
      iconSrc={iconSrc}
    />
  );
};

export default EventMarkerContainer;

